export const DEFAULT_CONTENT_URL = 'https://pmd.cdn.turner.com/xslo/cvp/assets/video/blank.mp4';
export const DEFAULT_MIME_TYPE = 'video/mp4';
export const DEFAULT_POSTER = 'https://i.cdn.turner.com/adultswim/big/video/mainstream/liveStream.jpg';
export const DEFAULT_VIDEO_ID = '';
export const EMBED_CODE_L = '<iframe width=\'560\' height=\'315\' src=\'';
export const EMBED_CODE_R = '\' frameborder=\'0\' allowfullscreen></iframe>';
export const EMBED_URL = 'https://www.adultswim.com/player/embed/';
export const ERROR_FETCHING_SOURCE_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2019/04/03/ERROR_slate.jpg';
export const FACEBOOK_SHARE_URL = 'https://facebook.com/sharer.php?u=';
export const FORBIDDEN_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2019/03/11/blocked_slate.jpg';
export const HLS_MIME_TYPE = 'application/x-mpegURL';
export const LIVE_STREAM_ID = 'r0xw2u30R3GchW27yVqlug';
export const LOCALSTORAGE_MUTED = 'as-player:muted';
export const NOT_FOUND_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2019/04/03/ERROR_slate.jpg';
export const PROBLEM_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2019/03/11/stream_problem_slate.jpg';
export const RECONNECTING_SLATE = 'https://i.cdn.turner.com/adultswim/big/img/2019/04/03/please_stay_tuned_slate.jpg';
export const STREAMS_SITE_URL = 'https://www.adultswim.com/streams';
export const TUMBLR_SHARE_URL = 'https://www.tumblr.com/share/link?url=';
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet?url=';
export const UNSUPPORTED_CSS_CLASS = 'your-browser-sux';
export const ERROR_CSS_CLASS = 'error';
export const VIDEO_SOURCE_QUERY_PARAMS = { 'fields': 'title,type,duration,collection_title,poster,stream,segments,title_id,auth,media_id,launch_date,auth_launch_date,disable_ads' };
export const VIDEO_SOURCE_URL = (window.location.hostname.includes('adultswim.com')) ? '/api/shows/v1/videos/' : '//www.adultswim.com/api/shows/v1/videos/';
export const MEDIA_JSON_SOURCE_URL = (window.location.hostname.includes('adultswim.com')) ? '/api/shows/v1/media/' : '//www.adultswim.com/api/shows/v1/media/';
export const VIDEOS_SITE_URL = 'https://www.adultswim.com/videos';
export const CDN_TOKEN_SERVICE_URL = 'https://token.ngtv.io/token/token_spe';
export const CDN_TOKEN_APP_ID = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6ImFzLXR2ZS1kZXNrdG9wLXB0enQ2bSIsInByb2R1Y3QiOiJ0dmUiLCJuZXR3b3JrIjoiYXMiLCJwbGF0Zm9ybSI6ImRlc2t0b3AiLCJpYXQiOjE1MzI3MDIyNzl9.BzSCk-WYOZ2GMCIaeVb8zWnzhlgnXuJTCu0jGp_VaZE';



// WEBPACK FOOTER //
// ./src/constants.js